export default __webpack_public_path__ + "static/media/private_img.e9a81a1d.png";